import { z } from "zod"
import { Element } from "../element"

// Version 1 ---------------------
export const ContainerSettingsV1 = z.object({
  backgroundColor: z.string(),
  backgroundImage: z.string(),
  backgroundOpacity: z.number(),
  badge: z.union([z.literal(true), z.literal(false)]),
  bleed: z.union([z.literal(true), z.literal(false)]),
  bleedBackground: z.union([z.literal(true), z.literal(false)]),
  bleedBottom: z.union([z.literal(true), z.literal(false)]),
  blur: z.union([z.literal(true), z.literal(false)]),
  card: z.union([z.literal(true), z.literal(false)]),
  cardRadius: z.string(),
  cover: z.union([z.literal(true), z.literal(false)]),
  extraLightBleed: z.union([z.literal(true), z.literal(false)]),
  fullHeight: z.union([z.literal(true), z.literal(false)]),
  fullWidth: z.union([z.literal(true), z.literal(false)]),
  heavyPadding: z.union([z.literal(true), z.literal(false)]),
  height: z.string(),
  inset: z.union([z.literal(true), z.literal(false)]),
  light: z.union([z.literal(true), z.literal(false)]),
  lightBleed: z.union([z.literal(true), z.literal(false)]),
  lightMargin: z.union([z.literal(true), z.literal(false)]),
  lightPadding: z.union([z.literal(true), z.literal(false)]),
  mediumMargin: z.union([z.literal(true), z.literal(false)]),
  noBackground: z.union([z.literal(true), z.literal(false)]),
  noMargin: z.union([z.literal(true), z.literal(false)]),
  noPadding: z.union([z.literal(true), z.literal(false)]),
  noTopPadding: z.union([z.literal(true), z.literal(false)]),
  showDivider: z.union([z.literal(true), z.literal(false)]),
  skipTag: z.union([z.literal(true), z.literal(false)]),
  style: z.string(),
  textAlign: z.string(),
  textColor: z.string(),
  width: z.string(),
})

export type TContainerSettingsV1 = z.infer<typeof ContainerSettingsV1>

export const ContainerElementV1 = z.object({
  id: z.string(),
  name: z.literal("container"),
  settings: ContainerSettingsV1,
  children: z.lazy(() => z.array(Element)),
})

export type TContainerElementV1 = z.infer<typeof ContainerElementV1>

// Latest ---------------------
export const ContainerSettings = ContainerSettingsV1
export type TContainerSettings = TContainerSettingsV1
export const ContainerElement = ContainerElementV1
export type TContainerElement = TContainerElementV1
